export default {
  LOCALE_HTML: {
    "msg.language": 'en',
    "msg.title": "Title",
    "msg.type": "Problem Types",
    "msg.des": "Problem description",
    "msg.phone":'Phone',
    "msg.email":'Email',
    'msg.choose': 'Please choose a business to leave a message',
    'msg.detail': 'Message details',
    'msg.back': 'Back',
    'your.msg': 'Your Message',
    'msg.record': 'Message record',
    'msg.success': 'Successfully  submitted',
    'to.record': 'Go to the message record',
    'completed':'Completed',
    'submit': 'Submit',
    'success.desc': 'Your message has been submitted successfully. Thank you for your feedback',
    'msg.form.input':'Please input',
    'msg.reply' : 'Reply',
    'msg.revoke' : 'Revoke',
    'comment.suc': 'Thank you for your evaluation!',
    'comment.fail': 'Failed',
    "comment.placeholder": "Tell us your suggestions",
    'reply.suc': 'Submitted successfully!',
    'reply.fail': 'Please enter your reply',
    'revoke.suc': 'Revoke successfully!',
    'revoke.fail': 'Revoke Failed',
    "reply.placeholder": 'Please enter your reply',
    "msg.more":"See More",
    "msg.collapse": 'Collapse',
    "msg.myservice": 'My service feedback',
    "msg.evaluate": 'Feedback',
    "msg.evaluateTitle": 'Feedback',
    "msg.score" : 'score:',
    "msg.remark" : 'Comment:',
    'msg.status.created': 'Created',
    'msg.status.pending': 'Pending',
    'msg.status.processing': 'Processing',
    'msg.status.solved': 'Solved',
    'msg.status.revoked': 'Revoked',
    'msg.service.reply': 'Service reply',
    'msg.my.reply': 'My reply',
    'msg.my.revoke': 'My revoke',
    "msg.toast.des":"Description Required",
    "msg.toast.type":"Problem Types Required",
    "msg.toast.title":"Title Required",
    "msg.toast.none":"cannot be empty",
    "msg.toast.noAnnex":"Please upload attachments",
    "msg.toast.noEmail":"Email Required",
    "msg.toast.noTel":"Phone Required",
    "msg.toast.email":"please enter the correct email",
    "msg.toast.tel":"please enter the correct Phone number",
    "msg.toast.num":"please enter the correct number",
    'msg.toast.annex': 'Please upload attachments',
    "msg.toast.char":"please enter the correct characte",
    "msg.list.none":"No Data",
    "msg.form.choose":"Please choose",
    "msg.form.sure":"Confirm",
    "msg.form.search":"search...",
    "msg.form.uploadError": "The format of the uploaded attachment does not meet the requirements",

    // "file.size.limit":"File size must less than 20MB",
    "file.size.limit":"File size must less than 200MB",
    // "detail.file.limit": "Up to 10 files, each within 20 MB",
    "detail.file.limit": "Up to 10 files, each within 200 MB",
    "form.question.des.tip": "Description Required",
    "form.title.tip": "Title Required",
    "form.class.tip": "Problem Types Required",
    "upload.file": "Upload attachments",
    "file.count.limit": "Upload no more than 10 attachments",
    "select.search.placeholder": "Search keywords",
    "msg.form.sizeError1": "Please upload attachments less than 5M",
    // "msg.form.sizeError2": "Please upload attachments less than 20M",
    "msg.form.sizeError2": "Please upload attachments less than 200M",
    "msg.form.submit": "submitting...",
    "msg.form.upload": "uploading...",
  },
  LOCALE_SYSTEM: {
    MSG005: ({ name }) => `Conversation with ${name} has been ended temporarily`,
    MSG012: (color) => ` You can <span style="color:${color};text-decoration:underline;" class="js-leave-msg">Leave message</span>`,
    MSG013: 'Send',
  }
}
